import script from "./PdfViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./PdfViewer.vue?vue&type=script&setup=true&lang=ts"

import "./PdfViewer.vue?vue&type=style&index=0&id=c1b718f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1b718f4"]])

export default __exports__